import React, { useState, useEffect } from "react";

function Login({ onLogin }) {
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(`sending: ${password}`);
    const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            token: password,
        }),
    });

    console.log(`response status: ${response.status}`);

    if (response.status === 200) 
    {
        document.cookie = `token=${password}; path=/; max-age=604800`;
        onLogin();
    }
    else 
    {
        alert("Unauthorized");
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchData = async () => {
        const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));

        try {
            const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    token: match[2],
                }),
            });

            if (response.status === 200) 
            {
                onLogin();
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    fetchData();
  }, [onLogin]);


  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
